import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { WorkspaceTagsNavigationType } from "@/components/WorkspaceTags/types";
import WorkspaceTagsPage from "@/components/WorkspaceTags/WorkspaceTagsPage";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/settings/tags")({
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith("settings/tags")) {
      throw redirect({
        to: "/workspaces/$workspace_id/settings/tags/$type",
        params: {
          workspace_id: params.workspace_id,
          type: WorkspaceTagsNavigationType.DeviceTags,
        },
      });
    }
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: WorkspaceTagsPage,
});
